function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_143_3",
  "data-name": "Component 143 \\u2013 3",
  transform: "translate(0.256 0.375)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_285",
  "data-name": "Rectangle 285",
  width: 6.771,
  height: 0.949,
  transform: "translate(0.119 24.14)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_286",
  "data-name": "Rectangle 286",
  width: 8.759,
  height: 1.61,
  transform: "translate(0 25.121)",
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_287",
  "data-name": "Rectangle 287",
  width: 10.915,
  height: 2.54,
  transform: "translate(0.119 26.598)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_288",
  "data-name": "Rectangle 288",
  width: 13.587,
  height: 4.829,
  transform: "translate(0 25.12)",
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_292",
  "data-name": "Rectangle 292",
  width: 15.666,
  height: 2.54,
  transform: "translate(89.236 26.598)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_293",
  "data-name": "Rectangle 293",
  width: 17.398,
  height: 4.829,
  transform: "translate(87.629 25.12)",
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_303",
  "data-name": "Rectangle 303",
  width: 11.268,
  height: 8.954,
  transform: "translate(13.587 0.071)",
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_305",
  "data-name": "Rectangle 305",
  width: 12.877,
  height: 26.458,
  transform: "translate(11.978 21.902)",
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_308",
  "data-name": "Rectangle 308",
  width: 12.877,
  height: 26.458,
  transform: "translate(44.17 21.902)",
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_311",
  "data-name": "Rectangle 311",
  width: 12.877,
  height: 26.458,
  transform: "translate(76.363 21.902)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_260",
  "data-name": "Path 260",
  d: "M629.488,205.041a4.767,4.767,0,0,1-1.4,3.371,4.792,4.792,0,0,1-6.753,0,4.771,4.771,0,1,1,8.155-3.371",
  transform: "translate(-590.505 -198.242)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_261",
  "data-name": "Path 261",
  d: "M655.592,205.041a4.8,4.8,0,0,1-1.4,3.371,4.783,4.783,0,0,1-3.377,1.389,4.751,4.751,0,0,1-3.376-8.123,4.771,4.771,0,0,1,8.149,3.363",
  transform: "translate(-585.097 -198.242)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_289",
  "data-name": "Rectangle 289",
  width: 17.246,
  height: 2.54,
  transform: "translate(25.855 26.598)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_290",
  "data-name": "Rectangle 290",
  width: 17.674,
  height: 2.54,
  transform: "translate(57.493 26.598)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_294",
  "data-name": "Rectangle 294",
  width: 2.352,
  height: 0.949,
  transform: "translate(8.683 24.14)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_295",
  "data-name": "Rectangle 295",
  width: 1.163,
  height: 0.949,
  transform: "translate(25.855 24.14)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_296",
  "data-name": "Rectangle 296",
  width: 7.15,
  height: 0.949,
  transform: "translate(28.804 24.14)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_297",
  "data-name": "Rectangle 297",
  width: 5.558,
  height: 0.949,
  transform: "translate(37.543 24.14)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_298",
  "data-name": "Rectangle 298",
  width: 7.771,
  height: 0.949,
  transform: "translate(57.493 24.14)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_299",
  "data-name": "Rectangle 299",
  width: 7.771,
  height: 0.949,
  transform: "translate(67.05 24.14)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_300",
  "data-name": "Rectangle 300",
  width: 4.711,
  height: 0.949,
  transform: "translate(89.238 24.14)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_301",
  "data-name": "Rectangle 301",
  width: 7.771,
  height: 0.949,
  transform: "translate(95.74 24.14)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_312",
  "data-name": "Rectangle 312",
  width: 5.728,
  height: 5.715,
  transform: "translate(1.075 17.311)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_313",
  "data-name": "Rectangle 313",
  width: 5.728,
  height: 5.715,
  transform: "translate(65.032 17.311)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_314",
  "data-name": "Rectangle 314",
  width: 2.967,
  height: 2.961,
  transform: "translate(97.381 20.066)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_315",
  "data-name": "Rectangle 315",
  width: 2.975,
  height: 2.961,
  transform: "translate(37.543 20.066)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_316",
  "data-name": "Rectangle 316",
  width: 2.975,
  height: 2.961,
  transform: "translate(32.978 20.066)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_317",
  "data-name": "Rectangle 317",
  width: 2.975,
  height: 2.967,
  transform: "translate(34.254 16.11)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_318",
  "data-name": "Rectangle 318",
  width: 2.975,
  height: 2.967,
  transform: "translate(66.019 13.57)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1680",
  "data-name": "Group 1680",
  transform: "translate(-63.859 0.075)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_272",
  "data-name": "Path 272",
  d: "M669.967,203.411a4.775,4.775,0,1,0-7.853,3.641h6.156a4.754,4.754,0,0,0,1.7-3.641",
  transform: "translate(-582.119 -198.648)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_276",
  "data-name": "Path 276",
  d: "M670.48,217.3H659v23.156a2.625,2.625,0,0,0,5.25,0v-19.1h.986v19.1a2.622,2.622,0,0,0,5.244,0Z",
  transform: "translate(-582.412 -194.785)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_273",
  "data-name": "Path 273",
  d: "M658.687,213.207a1.17,1.17,0,0,1-.082-.447v-.006a2.342,2.342,0,0,1,.321-1.1,5.421,5.421,0,0,1,.861-1.17v7.535h11.4s.039-2.879.056-6.286c.009-1.765.01-3.933-.017-5.413-2.309-.064-11.436.008-11.436.008-.151.069-.3.151-.453.233a9.281,9.281,0,0,0-2.7,2.408,6.361,6.361,0,0,0-1.427,3.785v.006a4.679,4.679,0,0,0,.283,1.578c.012.033.019.07.031.1A5.719,5.719,0,0,0,658,217.193a9.33,9.33,0,0,0,1.364.68v-3.849a1.977,1.977,0,0,1-.678-.817",
  transform: "translate(-583.199 -197.059)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_274",
  "data-name": "Path 274",
  d: "M668.876,218.021v-.853l.395.853,1.973.354a10.4,10.4,0,0,0,2.329.239,10.949,10.949,0,0,0,1.128-.051,1.7,1.7,0,0,0,1.534-1.868,1.723,1.723,0,0,0-1.912-1.5,7.109,7.109,0,0,1-.75.031,6.9,6.9,0,0,1-1.515-.151,1.533,1.533,0,0,1-.744-.32,3.608,3.608,0,0,1-.674-1.673,30.842,30.842,0,0,1-.2-3.7,5.655,5.655,0,0,0-.36-1.936,2.651,2.651,0,0,0-.8-1.135s-.036.339-.117,1.227a71.417,71.417,0,0,0-.278,9.628A4.542,4.542,0,0,0,668.876,218.021Z",
  transform: "translate(-580.955 -197.051)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_547",
  "data-name": "Path 547",
  d: "M2.038-.016a1.111,1.111,0,0,1,.935.541c.159,2.736,1.432,7.982.886,10.586a17.346,17.346,0,0,0-3.068-.17Z",
  transform: "translate(85.625 9.653)",
  fill: "#f8f8f8"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1681",
  "data-name": "Group 1681",
  transform: "translate(-31.801 0.075)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_272-2",
  "data-name": "Path 272",
  d: "M669.967,203.411a4.775,4.775,0,1,0-7.853,3.641h6.156a4.754,4.754,0,0,0,1.7-3.641",
  transform: "translate(-582.119 -198.648)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_276-2",
  "data-name": "Path 276",
  d: "M670.48,217.3H659v23.156a2.625,2.625,0,0,0,5.25,0v-19.1h.986v19.1a2.622,2.622,0,0,0,5.244,0Z",
  transform: "translate(-582.412 -194.785)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_273-2",
  "data-name": "Path 273",
  d: "M658.687,213.207a1.17,1.17,0,0,1-.082-.447v-.006a2.342,2.342,0,0,1,.321-1.1,5.421,5.421,0,0,1,.861-1.17v7.535h11.4s.039-2.879.056-6.286c.009-1.765.01-3.933-.017-5.413-2.309-.064-11.436.008-11.436.008-.151.069-.3.151-.453.233a9.281,9.281,0,0,0-2.7,2.408,6.361,6.361,0,0,0-1.427,3.785v.006a4.679,4.679,0,0,0,.283,1.578c.012.033.019.07.031.1A5.719,5.719,0,0,0,658,217.193a9.33,9.33,0,0,0,1.364.68v-3.849a1.977,1.977,0,0,1-.678-.817",
  transform: "translate(-583.199 -197.059)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_274-2",
  "data-name": "Path 274",
  d: "M668.876,218.021v-.853l.395.853,1.973.354a10.4,10.4,0,0,0,2.329.239,10.949,10.949,0,0,0,1.128-.051,1.7,1.7,0,0,0,1.534-1.868,1.723,1.723,0,0,0-1.912-1.5,7.109,7.109,0,0,1-.75.031,6.9,6.9,0,0,1-1.515-.151,1.533,1.533,0,0,1-.744-.32,3.608,3.608,0,0,1-.674-1.673,30.842,30.842,0,0,1-.2-3.7,5.655,5.655,0,0,0-.36-1.936,2.651,2.651,0,0,0-.8-1.135s-.036.339-.117,1.227a71.417,71.417,0,0,0-.278,9.628A4.542,4.542,0,0,0,668.876,218.021Z",
  transform: "translate(-580.955 -197.051)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_547-2",
  "data-name": "Path 547",
  d: "M2.038-.016a1.111,1.111,0,0,1,.935.541c.159,2.736,1.432,7.982.886,10.586a17.346,17.346,0,0,0-3.068-.17Z",
  transform: "translate(85.625 9.653)",
  fill: "#f8f8f8"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1682",
  "data-name": "Group 1682",
  transform: "translate(-0.551 -0.003)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_272-3",
  "data-name": "Path 272",
  d: "M669.967,203.411a4.775,4.775,0,1,0-7.853,3.641h6.156a4.754,4.754,0,0,0,1.7-3.641",
  transform: "translate(-582.119 -198.648)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_276-3",
  "data-name": "Path 276",
  d: "M670.48,217.3H659v23.156a2.625,2.625,0,0,0,5.25,0v-19.1h.986v19.1a2.622,2.622,0,0,0,5.244,0Z",
  transform: "translate(-582.412 -194.785)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_273-3",
  "data-name": "Path 273",
  d: "M658.687,213.207a1.17,1.17,0,0,1-.082-.447v-.006a2.342,2.342,0,0,1,.321-1.1,5.421,5.421,0,0,1,.861-1.17v7.535h11.4s.039-2.879.056-6.286c.009-1.765.01-3.933-.017-5.413-2.309-.064-11.436.008-11.436.008-.151.069-.3.151-.453.233a9.281,9.281,0,0,0-2.7,2.408,6.361,6.361,0,0,0-1.427,3.785v.006a4.679,4.679,0,0,0,.283,1.578c.012.033.019.07.031.1A5.719,5.719,0,0,0,658,217.193a9.33,9.33,0,0,0,1.364.68v-3.849a1.977,1.977,0,0,1-.678-.817",
  transform: "translate(-583.199 -197.059)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_274-3",
  "data-name": "Path 274",
  d: "M668.876,218.021v-.853l.395.853,1.973.354a10.4,10.4,0,0,0,2.329.239,10.949,10.949,0,0,0,1.128-.051,1.7,1.7,0,0,0,1.534-1.868,1.723,1.723,0,0,0-1.912-1.5,7.109,7.109,0,0,1-.75.031,6.9,6.9,0,0,1-1.515-.151,1.533,1.533,0,0,1-.744-.32,3.608,3.608,0,0,1-.674-1.673,30.842,30.842,0,0,1-.2-3.7,5.655,5.655,0,0,0-.36-1.936,2.651,2.651,0,0,0-.8-1.135s-.036.339-.117,1.227a71.417,71.417,0,0,0-.278,9.628A4.542,4.542,0,0,0,668.876,218.021Z",
  transform: "translate(-580.955 -197.051)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_547-3",
  "data-name": "Path 547",
  d: "M2.038-.016a1.111,1.111,0,0,1,.935.541c.159,2.736,1.432,7.982.886,10.586a17.346,17.346,0,0,0-3.068-.17Z",
  transform: "translate(85.625 9.653)",
  fill: "#f8f8f8"
})));

function SvgProduction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.533,
    height: 49.108,
    viewBox: "0 0 105.533 49.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/production.0f2a630880c070b572c407c5f0582108.svg";
export { ForwardRef as ReactComponent };